<template>
  <div class="d-first-screen" :class="{ isPcWeb }">
    <div v-if="isWeChat" class="is-wechat-tip">
      点击右上角的按钮<br>
      选择“浏览器中打开”
    </div>
    <div class="d-content d-mobile-content">
      <img :src="currentVersion.icon" alt="logo" class="d-app-logo">
      <p class="d-app-name">
        <span v-if="appType === 'Android'" class="d-icon iconfont icon-anzhuo"></span>
        <span v-else class="d-icon iconfont icon-ios"></span>
        <span>{{ appName }}</span>
      </p>
      <div class="d-divider"></div>
      <p class="d-version-desc" :class="{ 'show-latest-tip': showLatestTip }">
        {{ currentVersion.version || '1.0.0' }}（{{ appType }}）- {{ currentVersion.size || '未知大小' }}
        <br>
        更新于：{{ currentVersion.releaseTime | formatTime }}
        <span v-if="showLatestTip" class="lastest-tips">
          <span>当前版本不是最新，</span>
          <a @click="goLatestVersion">点击下载最新版本</a>
          <span class="close-tips" @click="showLatestTip = false">x</span>
        </span>
      </p>
      <div v-if="appType === 'Android' && isAndroid && isWeChat" class="d-tip">
        请使用其他浏览器打开
      </div>
      <a v-else-if="appType === 'Android' && isAndroid" :href="downloadUrlAndroid"
        class="d-download-btn">下载安装</a>
      <a v-else-if="appType === 'iOS' && isIPhone && isSafari
        && downloadStatus === 0" :href="downloadUrlIOS" class="d-download-btn"
        @click="downloadTap">下载安装</a>
      <p v-else-if="appType === 'iOS' && isIPhone && isSafari
        && downloadStatus === 1" class="d-download-status">下载中</p>
      <p v-else-if="appType === 'iOS' && isIPhone && isSafari
        && downloadStatus === 2" class="d-download-status">正在安装，请按 Home 键在桌面查看</p>
      <div v-else-if="appType === 'iOS' && isIPhone && !isSafari" class="d-tip">
        请使用 Safari 浏览器打开
      </div>
      <div v-else class="d-tip">
        只支持 {{ appType }} 设备
        <!-- <br> -->
        <!-- <a :href="otherPlatformWebUrl">点击前往 {{ appType === 'iOS' ? 'android' : 'iOS' }} 下载页</a> -->
      </div>
    </div>
    <div class="d-content d-pc-content">
      <div class="d-app-logo-box">
        <div class="qr-logo-bg"></div>
        <img :src="currentVersion.icon" alt="logo" class="d-app-logo">
        <div class="download-qr-box">
          <div ref="downloadQRCode" class="download-qr"></div>
        </div>
      </div>
      <p class="d-app-name">
        <span v-if="appType === 'Android'" class="d-icon iconfont icon-anzhuo"></span>
        <span v-else class="d-icon iconfont icon-ios"></span>
        <span>{{ appName }}</span>
      </p>
      <p class="d-web-tip">
        扫描二维码下载<br>
        或用手机浏览器输入这个网址：<span class="d-web-url">{{ webUrl }}</span>
      </p>
      <div class="d-divider"></div>
      <p class="d-version-desc">
        {{ currentVersion.version }}（{{ appType }}）- {{ currentVersion.size || '未知大小' }}
        <br>
        更新于：{{ currentVersion.releaseTime | formatTime }}
      </p>
    </div>
  </div>
</template>

<script>
import dayjs from 'dayjs';

export default {
  name: 'DownloadFirstScreen',
  filters: {
    formatTime(timeStamp) {
      return dayjs(timeStamp).format('YYYY-MM-DD');
    },
  },
  props: {
    currentVersion: {
      type: Object,
      default: () => {},
    },
    latestTips: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    appType() {
      return (location.pathname.indexOf('android') > -1) ? 'Android' : 'iOS';
    },
    downloadUrlAndroid() {
      return this.currentVersion.downloadUrl;
    },
    downloadUrlIOS() {
      return `itms-services://?action=download-manifest&url=${this.currentVersion.downloadUrl}`;
    },
    otherPlatformWebUrl() {
      return this.appType === 'iOS' ? window.location.href.replace('/ios-', '/android-') : window.location.href.replace('/android-', '/ios-');
    },
    appName() {
      return this.currentVersion.appName;
    },
    isPcWeb() {
      return !this.isIPhone && !this.isAndroid;
    }
  },
  data() {
    return {
      isIPhone: window.browser.iPhone || window.browser.iPad,
      isAndroid: window.browser.android,
      isSafari: window.browser.safari,
      isWeChat: window.browser.weChat,
      webUrl: window.location.href,
      // webUrl: `http://172.16.15.64:8080${window.location.pathname}${window.location.hash}`,
      downloadStatus: 0, // 下载状态：0-未开始现在，1-已开始现在，2-下载5秒后
      timer: null,
      showLatestTip: false
    };
  },
  mounted() {
    this.showLatestTip = this.latestTips;
    this.createDownloadQRCode();
  },
  beforeDestroy() {
    clearTimeout(this.timer);
  },
  methods: {
    // 创建下载地址 QRCode
    createDownloadQRCode() {
      this.$nextTick(() => {
        if (this.$refs.downloadQRCode) {
          /* eslint-disable-next-line */
          this.qrcode = new QRCode(this.$refs.downloadQRCode, {
            text: this.webUrl,
            width: 110,
            height: 110,
            colorDark: '#303133',
            colorLight: '#f2f2f2',
            /* eslint-disable-next-line */
            correctLevel: QRCode.CorrectLevel.L,
          });
        }
      });
    },
    // 下载点击
    downloadTap() {
      this.downloadStatus = 1;
      this.timer = setTimeout(() => {
        this.downloadStatus = 2;
      }, 5000);
    },
    goLatestVersion() {
      this.$router.push({
        query: {
          ...this.$route.query,
          version: ''
        }
      });
      history.go(0);
    }
  },
};
</script>

<style lang="scss" scoped>
@import "../assets/css/mixins.scss";
.d-first-screen {
  height: 100vh;
  text-align: center;
  position: relative;
  background: url("../assets/images/top_bg_mobile.png") no-repeat top center;
  background-size: contain;
  @include onepx-border-bottom(#dcdfe6);
  .is-wechat-tip {
    position: fixed;
    right: 8px;
    top: 16px;
    z-index: 999;
    background: #fac25b;
    color: #fff;
    padding: 8px 12px;
    font-size: 16px;
    line-height: 1.5;
    border-radius: 8px;
    &:after {
      display: block;
      content: "";
      width: 0;
      height: 0;
      position: absolute;
      right: 12px;
      top: -16px;
      border-width: 8px;
      border-style: solid;
      border-color: transparent transparent #fac25b transparent;
    }
  }
  .d-content {
    position: absolute;
    left: 0;
    right: 0;
    top: 50%;
    transform: translateY(-50%);
    &.d-mobile-content {
      .d-app-logo {
        width: 120px;
        height: 120px;
        border-radius: 10px;
      }
      .d-app-name {
        font-size: 24px;
        margin: 20px 0 30px;
        color: #303133;
        .iconfont {
          font-size: 24px;
          line-height: 33px;
          margin-right: 10px;
        }
      }
      .d-divider {
        width: 225px;
        height: 0;
        @include onepx-border-bottom(#dcdfe6);
        margin: 0 auto;
      }
      .d-version-desc {
        margin: 60px 0 30px;
        font-size: 14px;
        color: #909399;
        position: relative;
        &.show-latest-tip {
          margin-top: 80px;
        }
      }
      .d-download-btn {
        display: block;
        text-decoration: none;
        width: 200px;
        height: 46px;
        border-radius: 23px;
        background: #409EFF;
        color: #fff;
        font-size: 14px;
        line-height: 46px;
        border: 2px solid #409EFF;
        margin: 0 auto;
        cursor: pointer;
        transition: all .3s;
        &:hover {
          opacity: .8;
        }
      }
      .d-download-status {
        line-height: 50px;
        color: #909399;
      }
      span.lastest-tips {
        width: 210px;
        position: absolute;
        top: -40px;
        left: 50%;
        margin-left: -130px;
        border-style: solid;
        border-width: 1px;
        border-color: #dfe3e5;
        background-image: -moz-linear-gradient(90deg,#f9fbff 0,#fff 100%);
        background-image: -webkit-linear-gradient(
    90deg
    ,#f9fbff 0,#fff 100%);
        background-image: -ms-linear-gradient(90deg,#f9fbff 0,#fff 100%);
        box-shadow: 0 0 21px 0 rgb(166 171 173 / 24%);
        z-index: 5;
        padding: 8px 25px 5px;
        border-radius: 50px;
        font-size: 11px;
        display: flex;
        span {
          font-size: 11px;
          color: #969b9d;
          margin-left: -11px;
        }
        a {
          color: #29caad;
          margin-right: 6px;
          text-decoration: none;
        }
        span.close-tips {
          position: absolute;
          right: 6px;
          width: 26px;
          font-size: 14px;
          height: 100%;
          top: 0;
          cursor: pointer;
          text-align: center;
          padding-top: 5px;
        }
        &:after {
          content: '';
          position: absolute;
          bottom: -5px;
          left: 60px;
          border-right: 6px solid transparent;
          border-top: 6px solid #fff;
          border-left: 6px solid transparent;
        }
        &:before {
          content: '';
          position: absolute;
          bottom: -7px;
          left: 59px;
          border-right: 7px solid transparent;
          border-top: 7px solid #ccc;
          border-left: 7px solid transparent;
          border-top-color: #dfe3e5;
        }
      }
    }
    &.d-pc-content {
      width: 100%;
      max-width: 700px;
      display: none;
      .d-app-logo-box {
        width: 290px;
        height: 290px;
        position: relative;
        margin: 0 auto;
        .qr-logo-bg {
          width: 210px;
          height: 190px;
          background: #f2f2f2;
          position: absolute;
          top: 45px;
          left: 40px;
          transform: rotate(45deg);
        }
        .d-app-logo {
          box-sizing: content-box;
          width: 130px;
          height: 130px;
          background: #fff;
          padding: 10px;
          border-radius: 17.54%;
          position: absolute;
          top: -10px;
          left: -4px;
        }
        .download-qr-box {
          box-sizing: content-box;
          width: 110px;
          height: 110px;
          position: absolute;
          bottom: 4px;
          right: 0;
          background: #f2f2f2;
          border-radius: 26px;
          padding: 20px;
          .download-qr {
            width: 110px;
            height: 110px;
          }
        }
      }
      .d-app-name {
        font-size: 24px;
        margin: 20px 0 30px;
        color: #303133;
        text-align: left;
        padding-left: 200px;
        .iconfont {
          font-size: 24px;
          line-height: 33px;
          margin-right: 10px;
        }
      }
      .d-web-tip {
        color: #909399;
        text-align: left;
        padding-left: 200px;
        font-size: 14px;
        .d-web-url {
          color: #303133;
        }
      }
      .d-divider {
        width: 100%;
        height: 0;
        @include onepx-border-bottom(#dcdfe6);
        margin: 30px auto;
      }
      .d-version-desc {
        margin: 60px 0 30px;
        font-size: 14px;
        color: #909399;
      }
      .d-download-btn {
        width: 200px;
        height: 46px;
        border-radius: 23px;
        background: #409EFF;
        color: #fff;
        font-size: 14px;
        line-height: 42px;
        border: 2px solid #409EFF;
        margin: 0 auto;
        cursor: pointer;
        transition: all .3s;
        &:hover {
          opacity: .8;
        }
      }
    }
  }
  &.isPcWeb {
    background: none;
    .d-content {
      &.d-mobile-content {
        display: none;
      }
      &.d-pc-content {
        display: block;
      }
    }
  }
}
</style>
